import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { SourceName } from 'v2/core/entities/fields';
import { parseEQL } from 'v2/core/repository/eql/parser';

interface GetWhereClauseFromAssistantResponseEqlQuery {
  sourceDetailsMap: Map<SourceName, SourceDetail> | undefined;
  timezone: string;
  whereClause: string | undefined;
}

export const getWhereClauseFromAssistantResponseEqlQuery = ({
  sourceDetailsMap,
  timezone,
  whereClause,
}: GetWhereClauseFromAssistantResponseEqlQuery) => {
  if (!whereClause || !sourceDetailsMap) {
    return undefined;
  }

  const eql = whereClause.startsWith('select')
    ? whereClause
    : `select aggregates where ${whereClause}`;

  return parseEQL(eql, sourceDetailsMap, timezone).whereClause ?? undefined;
};
